import { render, staticRenderFns } from "./PersonaEdit.vue?vue&type=template&id=8f836ba0&scoped=true&"
import script from "./PersonaEdit.vue?vue&type=script&lang=js&"
export * from "./PersonaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f836ba0",
  null
  
)

export default component.exports